import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import ICreateOrderFromInventoryDTO from "../../../models/DTO/ICreateOrderFromInventoryDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetAllSupplierTokensDTO from "../../../models/DTO/IGetAllSupplierTokensDTO";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IOnCreateOrderFromInventoryDTO from "../../../models/DTO/IOnCreateOrderFromInventoryDTO";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetPriceGroupsDTO from "../../../models/DTO/IOnGetPriceGroupsDTO";
import IOnGetVendorsDTO from "../../../models/DTO/IOnGetVendorsDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ICatalog from "../../../models/ICatalog";
import ICatalog_ItemUI from "../../../models/ICatalog_ItemUI";
import IImageSizeEnum from "../../../models/IImageSizeEnum";
import INewOrder_Item from "../../../models/INewOrder_Item";
import INotification from "../../../models/INotification";
import IOwTableCols from "../../../models/IOwTableCols";
import IPrice_Group from "../../../models/IPrice_Group";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import IVendorModel from "../../../models/IVendorModel";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OrderEntryService from "../../../services/OrderEntryService";
import SupplierService from "../../../services/SupplierService";
import systemConst from "../../../services/SystemConst";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import "./InventoryCartSidebar.scss";
import Typeahead from "../../shared/Typeahead/Typeahead";
import OwS3ImageViewer from "../../shared/OwS3ImageViewer/OwS3ImageViewer";
import { Socket } from "socket.io-client";
import { QtyOnHandValue } from "../../shared/QtyOnHandValue/QtyOnHandValue";
import IOrder from "../../../models/IOrder";
import styled from "styled-components";

type Props = {
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    updateCartItems: (cartItems: ICatalog_ItemUI[]) => void;
    cancelFn: (refreshData?: boolean) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    vendorModel: IVendorModel;
    cartItems: ICatalog_ItemUI[];
    socket: Socket;
    history: any;
    catalogGuid: string;
    priceGroupGuid: string;
    selectedCatalog?: ICatalog | null;
    selectedPriceGroup?: IPrice_Group | null;
    selectedVendor?: IVendorModel | null;
};

type State = {
    cartItems: ICatalog_ItemUI[];
    hasChanges: boolean;
    columns: IOwTableCols[];
};

class InventoryCartSidebar extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            cartItems: this.props.cartItems,
            hasChanges: false,
            columns: [
                {
                    title: "",
                    valueProp: "",
                    isActionsCol: true,
                    renderFn: this.renderActionFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "sku",
                    valueProp: "sku",
                    renderFn: this.renderSkuFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "description",
                    valueProp: "description",
                    renderFn: this.renderDescriptionFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "qty",
                    valueProp: "",
                    renderFn: this.renderQtyFn,
                    renderFnEmitsRow: true,
                },
            ],
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.OrderOnCreateOrderFromInventory, this.onCreateOrderFromInventory);
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.OrderOnCreateOrderFromInventory, this.onCreateOrderFromInventory);
    }

    // onGetCatalogs = (data: IOnGetCatalogsDTO) => {
    //     let selectedCatalog = data.catalogs.find((catalog) => { return catalog.guid === this.props.catalogGuid; });
    //
    //     this.setState(
    //         {
    //             catalogs: data.catalogs,
    //             catalog: selectedCatalog? selectedCatalog.id : null
    //         },
    //         () => {
    //             if (this.props.vendorModel && !this.props.userModel.isSupplierUser) {
    //                 this.selectedVendor(this.props.vendorModel);
    //             }
    //         }
    //     );
    // };

    renderSkuFn = (row: ICatalog_ItemUI) => {
        return (
            <div>
                <div>{row.sku}</div>
                <div>
                    <OwS3ImageViewer
                        catalogItem={row}
                        isMicroView={true}
                        attachmentIndex={0}
                        imageIndex={IImageSizeEnum.THUMB}
                        className={"me-2 mb-2 mb-md-0"}
                        includeAllImages={true}
                        hideEmptyImage={true}
                    />
                </div>
            </div>
        );
    };

    renderDescriptionFn = (row: ICatalog_ItemUI) => {
        return (
            <div>
                <div dangerouslySetInnerHTML={{ __html: row.description || "" }}></div>
            </div>
        );
    };

    deleteItem = (row: ICatalog_ItemUI, index: number) => {
        const cartItems = this.state.cartItems;

        for (const item of cartItems) {
            if (item.guid === row.guid) {
                item.qty = 0;
                item.addedItem = false;
            }
        }

        cartItems.splice(index, 1);

        this.setState(
            {
                cartItems,
            },
            () => {}
        );
    };

    renderActionFn = (row: ICatalog_ItemUI, index: number) => {
        return (
            <i
                className={"fad fa-trash-alt text-danger pointer"}
                onClick={() => {
                    this.deleteItem(row, index);
                }}
            />
        );
    };

    handleQtyChange = (e: ChangeEvent<any>, row: ICatalog_ItemUI) => {
        const cartItems = this.state.cartItems;

        for (const item of cartItems) {
            if (item.guid === row.guid) {
                // validate if qty is allowed
                const qty = Number(e.target.value);
                const qtyDetail = OrderEntryService.doInventoryValidation(item, qty, [], this.props.supplierModel, {} as IOrder, 0);

                // const qtyDetail = OrderService.validateInventoryForItem(item, qty, [], false, item.qty || 0);

                console.log("handleQtyChange", qtyDetail, item);

                if (qtyDetail.enableAdd) {
                    item.qty = qtyDetail.qty;
                }
            }
        }

        this.setState({
            cartItems,
        });
    };

    renderQtyFn = (row: ICatalog_ItemUI, index: number) => {
        const step = SupplierService.getStep(this.props.supplierModel);

        return (
            <div>
                <OwInputWrapper
                    type={"number"}
                    name={"qty"}
                    fn={(e: ChangeEvent<any>) => {
                        this.handleQtyChange(e, row);
                    }}
                    value={row.qty}
                    step={step}
                    min={0}
                />
                <div className={"d-flex align-items-center"}>
                    <OwLabel title={"qty_on_hand"} postText={":"} className={"me-2"} />
                    <QtyOnHandValue catalogItem={row} />
                </div>
            </div>
        );
    };

    cancel = () => {
        this.props.updateCartItems(this.state.cartItems);

        this.props.cancelFn(false);
    };

    createOrder = () => {
        const catalogGuid = this.props.catalogGuid;
        let priceGroupGuid = this.props.priceGroupGuid;

        if (!priceGroupGuid && this.props.selectedVendor?.Price_Group) {
            priceGroupGuid = this.props.selectedVendor.Price_Group.guid;
        }

        if (!catalogGuid || !priceGroupGuid) {
            const message: INotification = {
                message: "missing_catalog_or_price_group",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bl,
            };

            this.props.notifyFn(null, message);
            return null;
        }

        const orderItems = this.state.cartItems.map((item) => {
            console.log("cartItems", item);
            const orderItem: Partial<INewOrder_Item> = {
                catalog_item_id: item.id,
                qty: item.qty || 0,
            };

            return orderItem;
        });

        const payload: ICreateOrderFromInventoryDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.vendorModel.guid,
            catalogGuid,
            priceGroupGuid,
            orderItems,
        };

        if (this.props.userModel.isSupplierUser) {
            if (this.props.selectedVendor) {
                payload.vendorGuid = this.props.selectedVendor.guid;
            }

            if (this.props.selectedCatalog) {
                payload.catalogGuid = this.props.selectedCatalog.guid;
            }

            if (this.props.selectedPriceGroup) {
                payload.priceGroupGuid = this.props.selectedPriceGroup.guid;
            }
        }

        this.props.socket.emit(EndpointsEnum.OrderCreateOrderFromInventory, payload);
    };

    onCreateOrderFromInventory = (data: IOnCreateOrderFromInventoryDTO) => {
        const url = `/orders/${data.orderGuid}/entry`;

        this.props.history(url);

        this.props.cancelFn(false);
    };

    render() {
        return (
            <SidebarContainer className="InventoryCartSidebar p-2">
                <div className={"d-flex flex-column pt-2 h-7r "} style={{ overflow: "hidden" }}>
                    <div className="text-end">
                        <OwButton centerIconClass={"far fa-times"} fn={this.cancel} className={"btn-danger"} />
                    </div>
                    <div className={"d-flex align-items-center"}>
                        <OwTitle className={"me-2"} leftIconName={"fad fa-shopping-cart"} title={"cart"} />
                        <div>
                            <OwButton
                                title={"create_order"}
                                fn={this.createOrder}
                                className={"btn-warning"}
                                leftIconClass={"fas fa-plus"}
                            />
                        </div>
                    </div>
                    <hr />
                </div>

                {this.props.userModel.isSupplierUser ? (
                    <div>
                        <div className={"mb-2"}>
                            <OwLabel
                                title={"vendor"}
                                isSupplierVendorOverride={true}
                                supplierModel={this.props.supplierModel}
                                isBold={true}
                                className={"text-end w-7r me-2"}
                                postText={":"}
                            />
                            {this.props.selectedVendor ? this.props.selectedVendor.name : null}
                        </div>
                        <div className={"mb-2"}>
                            <OwLabel title={"catalog"} className={"text-end w-7r me-2"} isBold={true} postText={":"} />
                            {this.props.selectedCatalog ? this.props.selectedCatalog.name : null}
                        </div>
                        <div className={"mb-2"}>
                            <OwLabel title={"price_group"} className={"text-end w-7r me-2"} isBold={true} postText={":"} />
                            {this.props.selectedPriceGroup ? this.props.selectedPriceGroup.value : null}
                        </div>
                    </div>
                ) : null}

                <TableContainer className={"w-40r"}>
                    <OwTable
                        wrappingClassName={"w-100"}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataSet={this.state.cartItems}
                        columns={this.state.columns}
                        dataFetch={false}
                        initialData={false}
                    />
                </TableContainer>
            </SidebarContainer>
        );
    }
}

export default InventoryCartSidebar;

const SidebarContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

const TableContainer = styled.div`
    overflow-y: scroll;
    display: flex;
    flex-grow: 1;
`;
